import { render } from "./ChatWindowSimple.vue?vue&type=template&id=b55f120c"
import script from "./ChatWindowSimple.vue?vue&type=script&lang=js"
export * from "./ChatWindowSimple.vue?vue&type=script&lang=js"

import "./ChatWindowSimple.vue?vue&type=style&index=0&id=b55f120c&lang=stylus"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__